<template>
    <!-- Шапка профиля -->
    <div class="profile-header mb-base">
        <div class="relative">
            <!-- Картинка в шапке, кнопки управления -->
            <div class="cover-container rounded-t-lg">
                <div
                    id="logo_image"
                    class="header_img lazyload bg-center"
                    ref="headerImg"

                >
                    <div
                        class="flex absolute z-20 top-0 right-0 mt-3 mr-3 head_img_btn"
                    >
                        <vx-tooltip
                            :text="
                                editStatus
                                    ? $t('save_changes')
                                    : $t('edit_desktop')
                            "
                        >
                            <vs-button
                                v-if="editDesktop"
                                class="mr-3 edit_desktop_btn"
                                radius
                                :color="editStatus ? 'success' : 'primary'"
                                @click="btnHandler()"
                                type="filled"
                                icon-pack="feather"
                                :icon="
                                    editStatus ? 'icon-save' : 'icon-settings'
                                "
                            />
                        </vx-tooltip>

                        <vx-tooltip v-if="!useSchedule" :text="$t('edit_header_background')">
                            <label
                                for="headImg"
                                class="cursor-pointer vs-component vs-button vs-button-primary vs-button-filled includeIcon includeIconOnly vs-radius"
                            >
                                <feather-icon icon="CameraIcon" />
                            </label>
                        </vx-tooltip>
                        <input
                            id="headImg"
                            name="headImg"
                            type="file"
                            v-on:change="handleFileChange()"
                            ref="headImg"
                            accept=".jpg, .jpeg, .png, .gif"
                            style="display: none"
                        />
                    </div>
                </div>
            </div>

            <!-- Аватар -->
            <div
                class="profile-img-container pointer-events-none pl-0 lg:pl-16"
            >
                <vs-avatar
                    v-if="user && user.avatar"
                    class="user-profile-img"
                    :src="user.avatar"
                    size="85px"
                />
                <div class="profile-actions pointer-events-auto flex">
                    <!--<vs-button icon-pack="feather" radius icon="icon-settings" class="ml-2 lg:ml-4"></vs-button>-->
                </div>
            </div>
        </div>

        <!-- Навигация -->
        <div
            class="flex  justify-end flex-wrap profile-header-nav p-4 mt-6 lg:mt-0"
        >
            <div
                :class="[
                    'nav_menu w-full flex-grow sm:flex sm:items-center sm:w-auto md:ml-auto',
                    showUserName ? 'justify-between' : 'justify-end',
                ]"
            >
                <h3 v-if="showUserName" class="font-semibold text-base lg:text-2xl mb-3 lg:mb-0 pt-5 lg:pt-0">
                    {{ userName }}
                    <p v-if="showID" class="font-semibold">ID: {{ user.student_id }}</p>
                </h3>
                <div class="pt-5 lg:pt-0" v-else></div>
                <div v-if="user && user.role.is_specialist">
                    <vs-button
                        :to="{
                            name: 'cabinet-specialist-view',
                            query: { specialist: true },
                        }"
                        color="primary"
                        type="border"
                    >
                        {{ $t("my_specialist_office") }}
                    </vs-button>
                    <vs-button
                        @click="specModal = true"
                        color="primary"
                        class="font-medium ml-0 mt-2 lg:ml-2 lg:mt-0"
                        type="filled"
                    >
                        {{ $t("edit_consultation_time") }}
                    </vs-button>
                </div>
            </div>
        </div>

        <template v-if="user && user.role.is_specialist">
            <vs-popup
                class="spec_popup"
                :title="$t('choose_a_specialist')"
                :active.sync="specModal"
            >
                <div
                    v-if="specList.length"
                    id="spec_loader"
                    class="vs-con-loading__container"
                >
                    <div
                        @click="selectSpec(item.uid)"
                        v-for="item in specList"
                        :key="item.uid"
                        class="mb-4 cursor-pointer text-primary"
                    >
                        <vs-alert
                            color="primary"
                            class="cursor-pointer"
                            :title="
                                item.specialist_type['name_' + $i18n.locale]
                            "
                            active="true"
                        >
                            {{ item[`subtitle_${$i18n.locale}`] }}
                        </vs-alert>
                    </div>
                </div>
            </vs-popup>

            <component
                v-bind:is="specModalCheck"
                :specialist="selectedSpec"
                v-model="dialogEdit"
            ></component>
        </template>
    </div>
</template>

<script>
import routes from "@/pages/Home/routers";
import ModalEdit from "@/pages/Home/CabinetSpecialist/ModalEdit";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";
import utils from "@/assets/utils";
import { mapGetters } from "vuex";

export const checkImageWidthHeight = (file) => {
    return new Promise(function (resolve) {
        let img = new Image();
        img.onload = function () {
            const width = img.width,
                height = img.height;

            resolve({ width, height });
        };
        img.src = window.URL.createObjectURL(file);
    });
};

export default {
    props: {
        editDesktop: {
            type: Boolean,
            default: false,
        },
        toggleEditHandler: {
            type: Function,
            default: () => {},
        },
        saveHander: {
            type: Function,
            default: () => {},
        },
        showUserName: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            isNavOpen: false,
            max_file_size: 10,
            minWidth: 1000,
            minHeight: 250,
            dialogEdit: false,
            specModal: false,
            specList: [],
            selectedSpec: null,
            logoImagePath: null
        };
    },
    watch: {
        specModal(val) {
            if (val && !this.specList.length) {
                this.getMySpec();
            }
        },
    },
    components: {
        ModalEdit,
    },
    computed: {
        ...mapGetters({
            GET_SCHEDULE: "system_settings/GET_SCHEDULE",
        }),
        user_role() {
            return this.$store.state.user.user.role
        },
        useSchedule(){
            return this.GET_SCHEDULE && this.GET_SCHEDULE.use_schedule
        },
        showID() {
            return this.GET_SCHEDULE && this.GET_SCHEDULE.use_schedule && this.user_role.is_student
        },
        specModalCheck() {
            if (this.selectedSpec)
                return () => import("@/pages/Home/CabinetSpecialist/ModalEdit");
        },
        editStatus() {
            return this.$store.state.desktop.edit;
        },
        userNav() {
            return routes.filter((item) => item.showUserNav);
        },
        user() {
            return this.$store.state.user.user;
        },
        userName() {
            // Если текущий язык английский, подставляем имя на англ
            if (this.$i18n.locale === "en") {
                // Если имя на англ пустое, используем рус имя
                if (this.user.first_name_en)
                    return `${ this.user.last_name_en } ${ this.user.first_name_en }`;
                else
                    return `${ this.user.lastName } ${ this.user.firstName } ${ this.user.middleName }`;
            } else
                return `${ this.user.lastName } ${ this.user.firstName } ${ this.user.middleName }`;
        },
        // headerImg() {
        //     if (this.user && this.user.header_picture)
        //         return this.user.header_picture.path;
        //     else
        //         return require("@/assets/images/pages/authorization-background.jpg");
        // },
    },
    async created() {
        await this.getLogoImagePathForUserHeader()
    },
    methods: {
        async getLogoImagePathForUserHeader(){
            const image_data = await utils.fetchLogoImage()

            // Если пользователь ставил свою картинку, берем его картинку и выходим
            if (this.user && this.user.header_picture){
                let element = document.getElementById("logo_image") ;
                element.setAttribute('style',  `background: url('${ this.user.header_picture.path }');`  )
                return
            }

            if (image_data.message && image_data.message === 'logo_image_not_found' ) {
                // Когда в бекенде нет данных берем картинку с фронта
                let element = document.getElementById("logo_image") ;
                element.setAttribute('style',  `background: url('${ require('@/assets/images/pages/authorization-background.jpg') }');`  )
            } else {
                // Берем картинку с бекенда, которую установил админ
                let element = document.getElementById("logo_image") ;
                element.setAttribute('style',  `background: url('${ image_data.path }');`  )

            }

        },
        selectSpec(uid) {
            this.specModal = false;
            this.selectedSpec = uid;
            this.dialogEdit = true;
        },
        async getMySpec() {
            try {
                this.$vs.loading();
                const { data } = await this.$http("/specialists/about-me/");
                if (data && data.length) this.specList = data;
            } catch (e) {
            } finally {
                this.$vs.loading.close();
            }
        },
        btnHandler() {
            if (this.editStatus) this.saveHander();
            else this.toggleEditHandler();
        },
        async handleFileChange() {
            try {
                this.$vs.loading({
                    container: ".header_img",
                    scale: 0.6,
                });

                const file = this.$refs.headImg.files[0],
                    fileSize = await checkImageWidthHeight(file);

                if (
                    fileSize.width >= this.minWidth &&
                    fileSize.height >= this.minHeight
                ) {
                    if (
                        this.max_file_size &&
                        file.size / 1024 / 1024 >= this.max_file_size
                    ) {
                        this.$vs.notify({
                            text: this.$t("image_max_size", {
                                max_file_size: this.max_file_size,
                            }),
                            color: "warning",
                        });
                    } else {
                        let formData = new FormData();
                        formData.append("path", file);

                        // Загружаем файлы на сервер
                        const { uid } = (
                            await this.$http.post("/common/upload/", formData, {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                },
                            })
                        ).data[0];

                        const { data } = await this.$http.put(
                            `/user/profile/${ this.user.profileId }/settings/edit/`,
                            {
                                header_picture: uid,
                            }
                        );

                        if (data) {
                            // Меняем атрибуты шапки
                            const headerImg = document.querySelector(
                                ".header_img"
                            );
                            headerImg.classList.remove("lazyloaded");
                            headerImg.setAttribute('style',  `background: url('${ data.header_picture.path }');`  )
                            // headerImg.style.backgroundImage = `url(${ data.header_picture.path })`;
                            headerImg.classList.add("lazyload");

                            this.$store.commit("user/SET_BY_KEY", {
                                key: "header_picture",
                                value: data.header_picture,
                            });
                            this.$vs.notify({
                                text: this.$t("header_image_change"),
                                color: "success",
                            });
                        }
                    }
                } else
                    this.$vs.notify({
                        text: this.$t("image_min_h_w", {
                            minWidth: this.minWidth,
                            minHeight: this.minHeight,
                        }),
                        color: "warning",
                    });
            } catch (e) {
                this.$vs.notify({
                    text: this.$t("error"),
                    color: "danger",
                });
            } finally {
                this.$vs.loading.close(".header_img > .con-vs-loading");
            }
        },
    },
};
</script>

<style lang="scss">
.spec_popup {
    .vs-popup {
        width: 440px !important;
    }
}
#spec_loader {
    position: relative;
    min-height: 50px;
    .con-vs-loading {
        position: absolute;
    }
}
.profile-header {
    .edit_desktop_btn {
        i {
            font-size: 18px;
        }
    }
}
.header_img {
    .con-vs-loading {
        position: absolute;
    }
}
</style>

<style lang="scss" scoped>
.dummy_btn {
    height: 39px;
    min-width: 5px;
}
.profile-header {
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
    .profile-img-container {
        display: flex;
        align-items: center;
        position: absolute;
        bottom: -3.6rem;
        left: 0;
        width: 80%;
        justify-content: space-between;
    }

    .user-profile-img {
        border: 0.3rem solid #fff;
        box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.3);
    }

    .user-latest-image {
        transition: all 0.2s ease-in-out;

        &:hover {
            transform: scale(1.2);
        }
    }

    .profile-header-nav {
        background-color: #fff;
        border-radius: 0 0 0.5rem 0.5rem;
    }
    .header_img {
        border-radius: 0.5rem 0.5rem 0 0;
        min-height: 150px;
        position: relative;
        background-position: center !important;
        background-repeat: no-repeat !important;
        background-size: cover !important;
        &:not(.lazyloaded) {
            background: rgba(0, 0, 0, 0.1);
        }
    }
}
.head_img_btn {
    svg {
        width: 18px;
        height: 18px;
    }
}
@media only screen and (min-width: 901px) {
    .nav_menu {
        padding-left: 12rem;
    }
}
@media only screen and (max-width: 900px) {
    .nav_menu {
        button {
            width: 100%;
        }
    }
}
@media (min-width: 560px) and (max-width: 1455px) {
    .nav_menu {
        padding-left: 11rem;
        button {
            padding: 0.579rem 0.5rem !important;
            font-size: 13px;
        }
        h3 {
            font-size: 1rem !important;
        }
    }
}
</style>
